import { render, staticRenderFns } from "./SyncStats.vue?vue&type=template&id=1fcd3897&"
import script from "./SyncStats.vue?vue&type=script&lang=js&"
export * from "./SyncStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports